import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import React from 'react';

interface ConfirmationModalProps {
	open: boolean;
	headerText: string;
	bodyText: string;
	handleSubmit: () => void;
	handleClose: () => void;
	cancelButtonText?: string;
	confirmButtonColor?:
		| 'inherit'
		| 'primary'
		| 'secondary'
		| 'success'
		| 'info'
		| 'warning';
	confirmButtonText?: string;
}

const ConfirmationModal = (props: ConfirmationModalProps) => {
	const {
		open,
		handleClose,
		handleSubmit,
		bodyText,
		headerText,
		cancelButtonText,
		confirmButtonText,
		confirmButtonColor = 'error',
	} = props;

	return (
		<Dialog
			open={open}
			onClose={handleClose}
			aria-labelledby='confirmation-dialog-title'
			aria-describedby='confirmation-dialog-description'
		>
			<DialogTitle id='confirmation-dialog-title'>{headerText}</DialogTitle>
			<DialogContent>
				<DialogContentText id='confirmation-dialog-description'>
					{bodyText}
				</DialogContentText>
			</DialogContent>
			<DialogActions>
				<Button variant='text' color='inherit' onClick={handleClose}>
					{cancelButtonText || 'Cancel'}
				</Button>
				<Button
					variant='contained'
					onClick={handleSubmit}
					color={confirmButtonColor}
					autoFocus
				>
					{confirmButtonText || 'Confirm'}
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default ConfirmationModal;
